import type { CallerConnectedStatus, LiveVideo } from '@/signalr';
import { VideoBox } from '@/features/video/VideoBox';
import type { IncidentState } from '@/signalr';

export type VideoBoxPlaceholderProps = {
  incidentId: string;
  incidentState: IncidentState | null;
  incidentIsReadOnly: boolean;
  incidentHasPhoneNumber: boolean;
  hasAppleEedVideoCapability: boolean;
  allowAppleEedVideoActions: boolean;
  appleEedVideoCallId?: string | null;
  liveVideos: readonly LiveVideo[];
  activeLiveVideoId: string | null;
  videoExpanded: boolean;
  onVideoExpandedChanged: (expanded: boolean) => void;
  callerConnectedStatus: CallerConnectedStatus;
};

export function VideoBoxPlaceholder(props: VideoBoxPlaceholderProps) {
  return <VideoBox {...props} />;
}
